module.exports = __webpack_public_path__ + "img/20191113161218360截图20191113160335127.b5c06039.jpg";